import styled from "styled-components";

export const Header = styled.header`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({theme}) => theme.spacing(1.5)};
    background-color: ${({theme}) => theme.color.base_contrast}; 
`;